import React, { FunctionComponent } from "react";
import { NodeProps } from "reactflow";
import { BasicNodeLayout, NodeType, NodeTypeCategory } from "../Base";
import { DataType } from "../TypeDefinitions";

globalThis.nodeTypeDefinitions.setDefinition({
  nodeType: NodeType.convertNumberToString,
  label: "Number To String",
  category: NodeTypeCategory.text,
  isExperimental: true,
  controlOutputs: [],
  dataInputs: [{ name: "source", type: DataType.DECIMAL, hideLabel: true }],
  dataOutputs: [{ name: "result", type: DataType.STRING }],
  evaluate: (input: any) => {
    return {
      output: { result: input.source.toString() },
      activeControlHandleIds: []
    };
  }
});

export const ConvertNumberToStringNode: FunctionComponent<NodeProps> = ({ id, data }) => {
  return <BasicNodeLayout id={id} data={data} />;
};
